import { Component, OnInit, HostListener, input, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser'
import { Router } from '@angular/router';
import { AppService } from '../../app.service';
import { AppSettings } from '../../app.settings';
import { PropertyFilterParameters } from '../../models/propertyFilterParameters';

@Component({ standalone: false,
  selector: 'app-header-image',
  templateUrl: './header-image.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./header-image.component.scss']
})
export class HeaderImageComponent implements OnInit {
  readonly backgroundImage = input<string>();
  readonly contentOffsetToTop = input<boolean>(false);
  readonly contentMinHeight = input<number>();
  readonly bgImageAnimate = input<boolean>(false);
  readonly title = input<string>();
  readonly desc = input<string>();
  readonly isHomePage = input<boolean>(false);

  public bgImage:any;

  private scrolledOut:boolean=false;

  constructor(private appSettings:AppSettings, private appService:AppService, private sanitizer:DomSanitizer, private router:Router) {
    setTimeout(() => {
      this.settings.headerBgImage = true;
    });
  }
  
  get settings(){
    return this.appSettings.settings;  
  }

  get showPropertySearch(){
    return this.isHomePage();
  }

  ngOnInit() {
    if(this.contentOffsetToTop()){
      setTimeout(() => {
        this.settings.contentOffsetToTop = this.contentOffsetToTop();
      }); 
    } 
    const backgroundImage = this.backgroundImage();
    if(backgroundImage){
      this.bgImage = this.sanitizer.bypassSecurityTrustStyle('url('+backgroundImage +')'); 
    }
  }

  ngOnDestroy(){
    setTimeout(() => {
      this.settings.headerBgImage = false; 
      this.settings.contentOffsetToTop = false;
    });  
  }

  @HostListener ('window:scroll') onWindowScroll() {
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    this.scrolledOut = (scrollTop > 250);
  }

  public onSearchItemSelected(pfp:PropertyFilterParameters){
    if(pfp.propertySearch?.goDirect && pfp.propertySearch.propertyIds){
      this.router.navigate(['/properties/'+pfp.propertySearch.propertyIds[0]]);
    }
    else{
      this.appService.setPresetPropertyFilterParameters(pfp, true)
      this.router.navigate(['/properties']);
    }
  }

}
